import React, { Component } from 'react'
import { connect } from 'react-redux'
import map from 'lodash/map'
import size from 'lodash/size'
import slice from 'lodash/slice'

import {
  Segment,
  Grid,
  Header,
  Modal,
  Table,
  Icon,
  Select,
  Form,
  Input,
  Button,
  Pagination,
} from 'semantic-ui-react'

import firebase from '../../config/firebase'
import DelivereeRow from '../../components/deliverees/row'
import DelivereeActions from '../../reducers/delivereeReducer'

const numberPerPage = 100

class Deliverees extends Component {
  constructor(props) {
    super(props)

    this.state = {
      deliverees: [],
      searching: false,
      currentPage: 1,
      numberOfPages: 1,
      searchText: '',
      searchType: 'phone',
      blocking: false,
      blockModalVisible: false,
      blockingUserData: null,
      blockTitle: '',
      blockDescription: '',
    }
  }

  componentDidMount() {
    const { searchDeliverees } = this.props

    this.setDeliverees(searchDeliverees)
  }

  componentWillReceiveProps(nextProps) {
    const { searchDeliverees } = this.props

    if (searchDeliverees !== nextProps.searchDeliverees) {
      this.setDeliverees(nextProps.searchDeliverees)
    }
  }

  setDeliverees = deliverees => {
    const delivereesArr = map(deliverees, (deliveree, deliveryUid) => ({
      ...deliveree,
      uid: deliveryUid,
    }))

    const pageSize = Math.ceil(size(delivereesArr) / numberPerPage)

    this.setState({
      deliverees: delivereesArr,
      numberOfPages: pageSize,
      currentPage: 1,
    })
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ currentPage: activePage })

  onBlockFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  onSearchTextKeyUp = event => {
    if (event.defaultPrevented) {
      return
    }

    const key = event.key || event.keyCode

    if (key === 'Enter') {
      this.searchingUser()
    }
  }

  onSearchTextChange = text => {
    if (text !== '\\') {
      this.setState({ searchText: text })
    } else {
      return
    }
  }

  onSelectChange = searchType => {
    this.setState({ searchType })
  }

  searchingUser = () => {
    const { setSearchDeliverees } = this.props
    const { searchType } = this.state
    let { searchText } = this.state

    if (searchText.length >= 2) {
      if (searchType === 'phone') {
        if (searchText.charAt(0) === '0') {
          searchText = searchText.substring(1, searchText.length)
        }

        searchText = `+855${searchText}`
      }

      const searchRef = firebase
        .database()
        .ref('deliverees')
        .orderByChild(searchType)
        .equalTo(searchText)

      this.setState({ searching: true })

      searchRef
        .once('value')
        .then(snapshot => {
          const deliverees = snapshot.val() || {}

          this.setState({ searching: false }, () => {
            setSearchDeliverees(deliverees)
          })
        })
        .catch(err => {
          alert(err)
          this.setState({ searching: false })
        })
    } else {
      alert('Please insert at least 2 characters')
    }
  }

  blockingToggle = (isBlocked, user) => {
    if (isBlocked) {
      this.unblockUser(user)
    } else {
      this.popUpBlockUser(user)
    }
  }

  popUpBlockUser = user => {
    const name = `${user.family_name} ${user.first_name}`

    this.setState({
      blockModalVisible: true,
      blockingUserData: {
        ...user,
        name,
      },
    })
  }

  blockUserValidation = () => {
    const { blockTitle, blockDescription } = this.state

    if (blockTitle.length > 0 && blockDescription.length > 0) {
      const conf = window.confirm(`Are you sure to block this user?`)

      if (conf) {
        this.blockUser()
      }
    } else {
      alert('Please fill in the title and description')
    }
  }

  blockUser = () => {
    const { blockingUserData, blockTitle, blockDescription } = this.state
    const { searchDeliverees, setSearchDeliverees } = this.props

    const updates = {}

    this.setState({ blocking: true })

    updates[`/deliverees/${blockingUserData.uid}/has_blocked`] = {
      title: blockTitle,
      description: blockDescription,
    }

    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) alert(err)

        this.setState({
          blocking: false,
          blockModalVisible: false,
          blockTitle: '',
          blockDescription: '',
          blockingUserData: null,
        })
      })

    setSearchDeliverees({
      ...searchDeliverees,
      [blockingUserData.uid]: {
        ...searchDeliverees[blockingUserData.uid],
        has_blocked: {
          title: blockTitle,
          description: blockDescription,
        }
      }
    })
  }

  unblockUser = user => {
    const { searchDeliverees, setSearchDeliverees } = this.props

    const name = `${user.family_name} ${user.first_name}`
    const conf = window.confirm(`Are you sure to unblock ${name}?`)

    if (conf) {
      const updates = {}
      updates[`/deliverees/${user.uid}/has_blocked`] = null

      firebase
        .database()
        .ref()
        .update(updates)

      setSearchDeliverees({
        ...searchDeliverees,
        [user.uid]: {
          ...searchDeliverees[user.uid],
          has_blocked: null
        }
      })
    }
  }

  renderDelivereeRows = () => {
    const { currentPage, deliverees } = this.state

    const begin = (currentPage - 1) * numberPerPage
    const end = begin + numberPerPage

    if (size(deliverees) > 0) {
      const pageList = slice(deliverees, begin, end)

      let id = begin
      const driverRows = map(pageList, deliveree => {
        id += 1

        return (
          <DelivereeRow
            key={deliveree.uid}
            data={deliveree}
            fireKey={deliveree.uid}
            id={id}
            blockingToggle={isBlocked => this.blockingToggle(isBlocked, deliveree)}
          />
        )
      })

      return driverRows
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan={6}>
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  renderBlockingForm = () => {
    const { blockTitle, blockDescription } = this.state
    return (
      <div>
        <Form>
          <Form.Input
            label="Title"
            placeholder="Main reason"
            onChange={e => this.onBlockFieldChange('blockTitle', e.target.value)}
            value={blockTitle}
          />
          <Form.TextArea
            label="Description"
            placeholder="Why block this user?"
            onChange={e => this.onBlockFieldChange('blockDescription', e.target.value)}
            value={blockDescription}
          />
        </Form>
      </div>
    )
  }

  render() {
    const {
      blockingUserData,
      deliverees,
      searchText,
      searchType,
      currentPage,
      numberOfPages,
      blockModalVisible,
      blocking,
      searching,
    } = this.state

    const options = [
      { key: 'phone', text: 'By Phone', value: 'phone' },
      { key: 'first_name', text: 'By Name', value: 'first_name' },
    ]

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <div
                style={{
                  marginBottom: 14,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div style={{ flex: 1, display: 'flex' }}>
                  <Header size="large">{`List Customers ${
                    size(deliverees) > 0 ? `(${size(deliverees)})` : ''
                  }`}</Header>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                  <Input
                    type="text"
                    placeholder={searchType === 'phone' ? 'e.g 012345678' : 'e.g Peter'}
                    size="small"
                    action
                    required
                    value={searchText}
                    onChange={e => this.onSearchTextChange(e.target.value)}
                    onKeyUp={e => this.onSearchTextKeyUp(e)}
                  >
                    <input />
                    <Select
                      compact
                      options={options}
                      value={searchType}
                      onChange={(e, { value }) => this.onSelectChange(value)}
                    />
                    <Button
                      icon
                      onClick={() => this.searchingUser()}
                      loading={searching}
                      disabled={searching}
                    >
                      <Icon name="search" />
                    </Button>
                  </Input>
                </div>
              </div>

              <Table basic="very">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>#</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Phone</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Last Session</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Created at</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{this.renderDelivereeRows()}</Table.Body>
                <Table.Footer>
                  {size(deliverees) > 0 && (
                    <Table.Row>
                      <Table.HeaderCell colSpan="7">
                        <Pagination
                          activePage={currentPage}
                          onPageChange={this.handlePaginationChange}
                          totalPages={numberOfPages}
                          floated="right"
                        />
                      </Table.HeaderCell>
                    </Table.Row>
                  )}
                </Table.Footer>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid>

        <Modal
          open={blockModalVisible}
          style={{ marginTop: 0 }}
          closeOnEscape={false}
          closeOnDimmerClick={false}
        >
          <Modal.Header>Blocking {(blockingUserData && blockingUserData.name) || ''}</Modal.Header>
          <Modal.Content>{this.renderBlockingForm()}</Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() =>
                this.setState({
                  blockModalVisible: false,
                  blockTitle: '',
                  blockDescription: '',
                  blockingUserData: null,
                })
              }
              negative
              disabled={blocking}
            >
              Cancel
            </Button>
            <Button loading={blocking} onClick={() => this.blockUserValidation()}>
              Block
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({ deliverees }) => ({
  searchDeliverees: deliverees.searchDeliverees,
})

const mapDispatchToProps = dispatch => ({
  setSearchDeliverees: data => dispatch(DelivereeActions.setSearchDeliverees(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Deliverees)



// WEBPACK FOOTER //
// ./src/containers/deliverees/index.js